module.exports = __webpack_public_path__ + "img/chest.9be3671f.png";